module.exports = __webpack_public_path__ + "static/main-photo3-4f190c0aed5fcbdc6d8909e61d9d8696.jpg";